package com.rainbowclubs.rainbow.domain.use_cases.events

import com.rainbowclubs.rainbow.domain.repositories.EventsRepository

class DeleteEventUseCase(
    private val eventsRepository: EventsRepository,
) {
    suspend operator fun invoke(eventId: String): Result<Unit> {
        return eventsRepository.deleteEvent(eventId)
    }
}
